<template>
    <div>
        <v-dialog v-model="crudDialog" fullscreen persistent>
            <v-card>
                <v-toolbar card color="primary" class="white--text" >
                    <v-toolbar-title><h4>{{ formTitle }}</h4></v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-model="editedItem.cuit"
                                        label="Cuit"
                                        :error-messages="cuitErrors"
                                        :counter="12"
                                        mask="##-########-#"
                                        required
                                        @input="$v.editedItem.cuit.$touch()"
                                        @blur="$v.editedItem.cuit.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                    v-model="editedItem.nombre"
                                    label="Nombre"
                                    :error-messages="nombreErrors"
                                    :counter="80"
                                    required
                                    @input="$v.editedItem.nombre.$touch()"
                                    @blur="$v.editedItem.nombre.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-model="editedItem.email"
                                        label="Email"
                                        :error-messages="emailErrors"
                                        @input="$v.editedItem.email.$touch()"
                                        @blur="$v.editedItem.email.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-model="editedItem.telefono"
                                        label="Telefono"
                                        :error-messages="telefonoErrors"
                                        @input="$v.editedItem.telefono.$touch()"
                                        @blur="$v.editedItem.telefono.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-model="editedItem.localidad"
                                        label="Localidad"
                                        :counter="100"
                                        :error-messages="localidadErrors"
                                        @input="$v.editedItem.localidad.$touch()"
                                        @blur="$v.editedItem.localidad.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-model="editedItem.direccion"
                                        label="Telefono"
                                        :counter="100"
                                        :error-messages="direccionErrors"
                                        @input="$v.editedItem.direccion.$touch()"
                                        @blur="$v.editedItem.direccion.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-switch
                                        label="Habilitado"
                                        v-model="editedItem.enabled"
                                ></v-switch>
                            </v-flex>
                        </v-layout>
                    </v-container>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" :disabled="$v.$invalid" @click.native="save">Guardar</v-btn>
                    <v-btn color="secondary" @click.native="close">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-card>
            <v-toolbar card>
                <v-btn
                    fab
                    small
                    color="success"
                    bottom
                    left
                    absolute
                    @click="addItem"
                    >
                    <v-icon>add</v-icon>
                </v-btn>


                <v-toolbar-title><h4>Gestión de Derivadores</h4></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                        v-model="searchFilter.name"
                        append-icon="search"
                        label="Buscar"
                        single-line
                        @change="onSearchfilterChanged"
                        hide-details
                ></v-text-field>
            </v-toolbar>
            <v-card-text class="pa-0">
                <template>
                    <v-data-table
                            :headers="headers"
                            :items="items"
                            :total-items="totalItems"
                            :pagination.sync="pagination"
                            :loading="loading"
                            :hide-actions="loading"
                            class="elevation-0"
                    >
                        <template slot="items" slot-scope="props">
                            <td>{{ props.item.cuit }}</td>
                            <td>{{ props.item.nombre }}</td>
                            <td>{{ props.item.email }}</td>
                            <td><v-icon>{{ props.item.enabled ? 'check' : 'close' }}</v-icon></td>
                            <td>{{ props.item.created.format('DD-MM-YYYY hh:mm') }}</td>
                            <td class="text-xs-right">
                                <v-btn flat icon color="teal" @click="editItem(props.item)">
                                    <v-icon>edit</v-icon>
                                </v-btn>
                                <v-btn flat icon color="pink" @click="deleteItem(props.item)">
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </td>
                        </template>
                    </v-data-table>
                </template>
                <v-divider></v-divider>
            </v-card-text>
            <v-snackbar color="error" error v-if="error" :timeout="errorTimeout" :bottom="true"
                        v-model="error">
                {{ errorMessage }}
                <v-btn secondary flat @click.native="error = false">Close</v-btn>
            </v-snackbar>
            <v-snackbar color="success" v-if="success" :timeout="successTimeout" :bottom="true"
                        v-model="success">
                {{ successMessage }}
            </v-snackbar>
        </v-card>
    </div>

</template>

<script>
  import { required, maxLength, email } from 'vuelidate/lib/validators'
  import moment from 'moment'
  import qs from 'qs'
  import {phoneValidator, cuitValidator} from '@/util/validators'

  export default {
    data () {
      return {
        error: false,
        errorMessage: '',
        errorTimeout: 6000,
        success: false,
        successMessage: '',
        successTimeout: 2000,
        searchFilter: {
          name: ''
        },
        items: [],
        totalItems: 0,
        pagination: {
          page: 1,
          search: ''
        },
        crudDialog: false,
        editedIndex: -1,
        editedItem: {
          id: '',
          nombre: '',
          cuit: '',
          email: '',
          enabled: true,
          telefono: '',
          direccion: '',
          localidad: '',
          created: moment(),
          updated: moment()
        },
        defaultItem: {
          id: '',
          nombre: '',
          cuit: '',
          email: '',
          enabled: true,
          telefono: '',
          direccion: '',
          localidad: '',
          created: moment(),
          updated: moment()
        },
        loading: false,
        headers: [
          {
            text: 'Cuit',
            align: 'left',
            sortable: false,
            value: 'cuit'
          },
          {
            text: 'Nombre',
            align: 'left',
            sortable: true,
            value: 'nombre'
          },
          {
            text: 'Email',
            align: 'left',
            sortable: true,
            value: 'email'
          },
          {
            text: 'Habilitado',
            align: 'left',
            sortable: true,
            value: 'enabled'
          },
          {
            text: 'Creado',
            align: 'left',
            sortable: true,
            value: 'created'
          },
          { text: 'Acciones', value: 'action', align: 'right', sortable: false }
        ]
      }
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo Derivador' : 'Editar Derivador'
      },
      nombreErrors () {
        let errors = []
        if (!this.$v.editedItem.nombre.$dirty) return errors
        !this.$v.editedItem.nombre.maxLength && errors.push('Máximo 30 caracteres')
        !this.$v.editedItem.nombre.required && errors.push('El nombre es requerido.')
        return errors
      },
      cuitErrors () {
        let errors = []
        if (!this.$v.editedItem.cuit.$dirty) return errors
        !this.$v.editedItem.cuit.cuitValidator && errors.push('CUIT inválido')
        !this.$v.editedItem.cuit.required && errors.push('El CUIT es requerido.')
        return errors
      },
      matriculaErrors () {
        let errors = []
        if (!this.$v.editedItem.matricula.$dirty) return errors
        !this.$v.editedItem.matricula.maxLength && errors.push('Máximo 30 caracteres')
        !this.$v.editedItem.matricula.required && errors.push('La matrícula es requerida.')
        return errors
      },
      direccionErrors () {
        let errors = []
        if (!this.$v.editedItem.direccion.$dirty) return errors
        !this.$v.editedItem.direccion.maxLength && errors.push('Máximo 30 caracteres')
        !this.$v.editedItem.direccion.required && errors.push('La direccion es requerida.')
        return errors
      },
      localidadErrors () {
        let errors = []
        if (!this.$v.editedItem.localidad.$dirty) return errors
        !this.$v.editedItem.localidad.maxLength && errors.push('Máximo 30 caracteres')
        !this.$v.editedItem.localidad.required && errors.push('La localidad es requerida.')
        return errors
      },
      emailErrors () {
        let errors = []
        if (!this.$v.editedItem.email.$dirty) return errors
        !this.$v.editedItem.email.required && errors.push('Email requerido.')
        !this.$v.editedItem.email.email && errors.push('Email inválido')
        return errors
      },
      telefonoErrors () {
        let errors = []
        if (!this.$v.editedItem.telefono.$dirty) return errors
        !this.$v.editedItem.telefono.required && errors.push('Teléfono requerido.')
        !this.$v.editedItem.telefono.phoneValidator && errors.push('Teléfono inválido')
        return errors
      }
    },
    methods: {
      getDataFromApi () {
        this.loading = true
        const {sortBy, descending, page, rowsPerPage, search} = this.pagination
        this.axios.post('/derivadores',
          qs.stringify(
            {
              page,
              rowsPerPage,
              sortBy,
              descending,
              search
            })).then(
          response => {
            this.items = response.data.data.map(function (item) {
              item.created = moment(item.created)
              item.updated = moment(item.updated)
              return item
            })
            this.totalItems = response.data.total_entries
            this.loading = false
          }
        ).catch(
          err => {
            console.log(err)
            this.loading = false
            this.errorMessage = 'Error al cargar listado'
            this.error = true
          }
        )
      },
      addItem () {
        this.crudDialog = true
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
        this.editedIndex = -1
        this.$v.$reset()
      },
      deleteItem (item) {
        this.$root.$confirm('Borrar Derivador', `¿Está seguro de borrar el derivador ${item.nombre} ?`, { color: 'error' }).then(
          (confirm) => {
            if (confirm === true) {
              this.axios.delete('/derivadores/delete/' + item.id).then(
                response => {
                  this.successMessage = 'Derivador borrado exitosamente.'
                  this.success = true
                  this.getDataFromApi()
                  this.close()
                }
              ).catch(
                _ => {
                  this.errorMessage = 'Error al borrar el derivador'
                  this.error = true
                  this.close()
                }
              )
            }
          },
          (reject) => { console.log(reject) })
      },
      editItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = JSON.parse(JSON.stringify(item))
        this.editedItem.created = moment(this.editedItem.created)
        this.editedItem.updated = moment(this.editedItem.updated)
        this.crudDialog = true
      },
      close () {
        this.crudDialog = false
        setTimeout(() => {
          this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
          this.$v.$reset()
        }, 300)
      },
      save () {
        let url = ''
        if (this.editedIndex > -1) {
          url = '/derivadores/update'
        } else {
          url = '/derivadores/add'
        }
        this.axios.post(url, this.editedItem).then(
          response => {
            this.successMessage = 'Derivador guardado exitosamente.'
            this.success = true
            this.getDataFromApi()
            this.close()
          }
        ).catch(
          _ => {
            this.errorMessage = 'Error al guardar derivador.'
            this.error = true
            this.close()
          }
        )
      },
      onSearchfilterChanged () {
        this.pagination.search = this.searchFilter.name
        this.pagination.page = 1
      }
    },
    validations: {
      editedItem: {
        nombre: {required, maxLength: maxLength(80)},
        cuit: {required, cuitValidator},
        email: {required, email},
        telefono: {required, phoneValidator},
        localidad: {required, maxLength: maxLength(100)},
        direccion: {required, maxLength: maxLength(100)}
      }
    },
    watch: {
      pagination: {
        handler () {
          this.getDataFromApi()
        },
        deep: true
      }
    },
    components: {
    },
    mounted () {
    },
    name: 'DerivadorList'
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Management/DerivadorList.vue